/** Session persistence for report plan recommendation implementations. */

const STORAGE_PREFIX = 'reportPlanImplementations:';

export const IMPLEMENTATION_STATUS = {
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
};

export function storageKey(reportGenerationId) {
    return `${STORAGE_PREFIX}${reportGenerationId}`;
}

export function loadImplementations(reportGenerationId) {
    if (!reportGenerationId) return [];
    try {
        const raw = sessionStorage.getItem(storageKey(reportGenerationId));
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

export function saveImplementations(reportGenerationId, items) {
    if (!reportGenerationId) return;
    try {
        sessionStorage.setItem(storageKey(reportGenerationId), JSON.stringify(items));
    } catch (e) {
        console.warn('Failed to persist plan implementations', e);
    }
}

export function clearImplementations(reportGenerationId) {
    if (!reportGenerationId) return;
    try {
        sessionStorage.removeItem(storageKey(reportGenerationId));
    } catch {
        /* ignore */
    }
}

export function upsertImplementation(reportGenerationId, index, recommendation, outcome) {
    const items = loadImplementations(reportGenerationId);
    const rest = items.filter((item) => item.index !== index);
    const next = [...rest, { index, recommendation, outcome }].sort(
        (a, b) => a.index - b.index
    );
    saveImplementations(reportGenerationId, next);
    return next;
}

export function isCompletedImplementation(item) {
    return item?.outcome?.status === IMPLEMENTATION_STATUS.COMPLETED;
}

export function buildReportPlanReturnPath(databaseId, reportGenerationId) {
    return `/reports/${databaseId}?view=${reportGenerationId}`;
}
